import { fetchPatch } from 'Services/fetchService.js';
import { nodePath } from 'Config/path.js';
import { TasksSetTagsRequest, TasksSetTagsResponse } from 'CommonTypes/Tags/TasksTags';

export default async (data: TasksSetTagsRequest) => {
    const response: TasksSetTagsResponse = await fetchPatch(`${nodePath}/tasks/tags/${data.taskId}`, { tagsIds: data?.tagsIds || [], preserveSubprojectTags: data?.preserveSubprojectTags || 0 });

    return response;
};
